<button
  type="button"
  class="email-launcher-trigger"
  [matMenuTriggerFor]="menu"
  [matTooltip]="tooltip"
  matTooltipPosition="above"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
  aria-label="Email">
  <mat-icon>mail</mat-icon>
</button>

<mat-menu #menu="matMenu" class="email-launcher-menu" [overlapTrigger]="false">
  <!-- Everything is custom markup (no mat-menu-item), so we own the layout and close
       the menu ourselves. stopPropagation keeps clicks/keys from bubbling to the menu. -->
  <div class="elm" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">

    <!-- Search -->
    <div class="elm-search">
      <mat-icon>search</mat-icon>
      <input
        type="text"
        [(ngModel)]="searchTerm"
        (ngModelChange)="filter()"
        placeholder="Search templates…"
        aria-label="Search templates" />
      @if (searchTerm) {
        <button type="button" class="elm-search-clear" (click)="searchTerm=''; filter()" aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <!-- New Email — primary action -->
    <button type="button" class="elm-row elm-new" (click)="newEmail()">
      <span class="elm-new-ic"><mat-icon>edit</mat-icon></span>
      <span class="elm-tx">
        <span class="elm-title">New Email</span>
        <span class="elm-sub">Start from a blank message</span>
      </span>
    </button>

    <div class="elm-label">
      <span>Templates</span>
      @if (!loading) { <span class="elm-count">{{ filtered.length }}</span> }
    </div>

    <!-- Scrollable template list -->
    <div class="elm-list">
      @if (loading) {
        <div class="elm-state"><span class="elm-spinner"></span> Loading templates…</div>
      } @else {
        @for (t of filtered; track t.id) {
          <button type="button" class="elm-row elm-tpl" (click)="useTemplate(t)">
            <span class="elm-tpl-ic"><mat-icon>description</mat-icon></span>
            <span class="elm-tx">
              <span class="elm-title elm-tpl-name">{{ t.template_name }}</span>
              @if (t.description) { <span class="elm-sub">{{ t.description }}</span> }
            </span>
            @if (t.is_default) { <span class="elm-badge">Default</span> }
          </button>
        }
        @if (!filtered.length) {
          <div class="elm-state elm-empty">
            <mat-icon>{{ searchTerm ? 'search_off' : 'description' }}</mat-icon>
            <span>{{ searchTerm ? 'No templates match your search' : 'No templates for this module' }}</span>
          </div>
        }
      }
    </div>
  </div>
</mat-menu>
